import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import ViewAgentScreen from '../component/ViewAgentScreen';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import Constants, { LIMIT } from '../utils/Constants';
import Alert from '../component/alert/alert';

const HISTORY_DATE_FILTERS = [
    { key: 'all', labelKey: 'HISTORY_DATE_ALL' },
    { key: 'today', labelKey: 'HISTORY_DATE_TODAY' },
    { key: 'yesterday', labelKey: 'HISTORY_DATE_YESTERDAY' },
    { key: 'this_week', labelKey: 'HISTORY_DATE_THIS_WEEK' },
    { key: 'this_month', labelKey: 'HISTORY_DATE_THIS_MONTH' },
];

class ViewAgent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            isLoading: false,
            isSrmIpAgent: 0,
            pageNumber: 1,
            totalItems: '',
            list: [],
            showDeleteModal: false,
            deleteItem: null,
            datePreset: 'all',
        }
    }
    componentDidMount() {
        const { agentSelectedId, isAgent } = this.props;
        let param = {
            id: agentSelectedId
        }
        const callback = (response) => {
            this.setState({ data: response?.response, isLoading: false })
            let isSrmIpAgent = response?.response?.vendorAgentDetails?.length > 0 ? response?.response?.vendorAgentDetails[0]?.isSrmIpAgent : response?.response?.VendorAgent?.isSrmIpAgent
            this.getCallHistory(isSrmIpAgent)
        }
        this.setState({ isLoading: true })
        this.props.adminAgentDetails(param, callback, isAgent)
    }
    setLoading = (state) => {
        this.setState({ isLoading: state })
    }
    getCallHistory(isSrmIpAgent, pageNumber = 0, datePreset = this.state.datePreset) {
        const { agentSelectedId, isAgent } = this.props
        let param = {
            id: agentSelectedId,
            limit: LIMIT,
            pageNumber,
            isSrmIpAgent: isSrmIpAgent,
            ...(datePreset && datePreset !== 'all' ? { datePreset } : {}),
        }
        const callback = (response) => {
            this.setState({
                list: response?.response?.historys,
                totalItems: response?.response?.totalItems,
                isLoading: false,
                isSrmIpAgent: isSrmIpAgent,
                pageNumber: pageNumber + 1,
                datePreset,
            })
        }
        this.setState({ isLoading: true })
        if (!isAgent) {
            this.props.vendorAgentCall(param, callback)
        } else {
            this.props.adminAgentCall(param, callback)
        }
    }
    setDatePreset = (datePreset) => {
        if (datePreset === this.state.datePreset) return;
        this.getCallHistory(this.state.isSrmIpAgent, 0, datePreset);
    }
    onChangePagination = (pageNumber) => {
        const { agentSelectedId, isAgent } = this.props
        const { isSrmIpAgent, datePreset } = this.state
        let params = {
            id: agentSelectedId,
            pageNumber: (pageNumber - 1),
            limit: LIMIT,
            isSrmIpAgent: isSrmIpAgent,
            ...(datePreset && datePreset !== 'all' ? { datePreset } : {}),
        }
        const callBack = (response) => {
            this.setState({ list: response?.response?.historys, totalItems: response?.response?.totalItems, isLoading: false, pageNumber })
        }
        this.setState({ isLoading: true })
        if (!isAgent) {
            this.props.vendorAgentCall(params, callBack)
        } else {
            this.props.adminAgentCall(params, callBack)
        }
    }
    openDeleteModal = (item) => {
        if (!item?.id) return;
        this.setState({ showDeleteModal: true, deleteItem: item });
    }
    closeDeleteModal = () => {
        this.setState({ showDeleteModal: false, deleteItem: null });
    }
    confirmDeleteHistory = () => {
        const { deleteItem, isSrmIpAgent, pageNumber, datePreset } = this.state;
        if (!deleteItem?.id) {
            this.closeDeleteModal();
            return;
        }
        const params = {
            id: deleteItem.id,
            isSrmIpAgent,
        };
        const callback = (response) => {
            this.closeDeleteModal();
            if (response?.response_code === 0) {
                toast.success(Constants.DELETED_SUCCESSFULLY);
                this.getCallHistory(isSrmIpAgent, Math.max(0, (pageNumber || 1) - 1), datePreset);
            } else {
                toast.error(response?.response_message || 'Unable to delete history');
                this.setState({ isLoading: false });
            }
        };
        this.setState({ isLoading: true });
        this.props.vendorAgentDeleteHistory(params, callback);
    }
    render() {
        const { data, isLoading, list, pageNumber, totalItems, showDeleteModal, datePreset } = this.state;
        const { isAgent } = this.props;
        const canDeleteHistory = !isAgent;
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div>
                            <ViewAgentScreen
                                agentData={data}
                                list={list}
                                pageNumber={pageNumber}
                                totalItems={totalItems}
                                onChangePagination={(e) => this.onChangePagination(e)}
                                canDeleteHistory={canDeleteHistory}
                                onDeleteHistory={this.openDeleteModal}
                                datePreset={datePreset}
                                dateFilters={HISTORY_DATE_FILTERS}
                                onDatePresetChange={this.setDatePreset}
                            />
                        </div>
                    </div>
                </div>
                {isLoading && <AppLoader />}
                {canDeleteHistory && showDeleteModal ? (
                    <Alert
                        title={Constants.DELETE_HISTORY_TITLE}
                        description={Constants.DELETE_HISTORY_MSG}
                        proceed={Constants.YES}
                        cancel={Constants.NO}
                        onSuccess={this.confirmDeleteHistory}
                        onFailure={this.closeDeleteModal}
                    />
                ) : null}
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        agentSelectedId: state?.AGENR_DETAILS?.agentSelectedId?.id,
        isAgent: state?.AGENR_DETAILS?.agentSelectedId?.agent,
        agentState: state?.AGENR_DETAILS
    }
};
export default withRouter(connect(mapStateToProps, {
    adminAgentDetails: Actions.getAdminAgentDetails,
    adminAgentCall: Actions.adminAgentCallHistoryAction,
    vendorAgentCall: Actions.vendorAgentCallHistoryAction,
    vendorAgentDeleteHistory: Actions.vendorAgentDeleteHistoryAction,
})(ViewAgent));
